export default __webpack_public_path__ + "static/media/junk2.be23e54f.svg";